import { AlertTriangle } from 'lucide-react';
import { isRouteErrorResponse, useRouteError } from 'react-router';
import { Button } from '@/components/ui/button';

/** Also catches failed lazy-chunk loads after a deploy, where a reload fixes it. */
export function RouteError() {
  const error = useRouteError();
  const chunkFailed =
    error instanceof TypeError &&
    /dynamically imported module|Importing a module script/i.test(error.message);
  const message = isRouteErrorResponse(error)
    ? `${error.status} ${error.statusText}`
    : error instanceof Error
      ? error.message
      : 'Unknown error';
  return (
    <div role="alert" className="grid min-h-[60vh] place-content-center gap-3 p-6 text-center">
      <AlertTriangle className="mx-auto size-8 text-destructive" />
      <h1 className="text-base font-semibold">
        {chunkFailed ? 'A new version is available' : 'Something went wrong'}
      </h1>
      <p className="max-w-md text-ui text-muted-foreground">
        {chunkFailed ? 'Reload the page to continue.' : message}
      </p>
      <div className="flex justify-center gap-2">
        <Button onClick={() => window.location.reload()}>Reload</Button>
        <Button variant="outline" onClick={() => window.location.assign('/')}>
          Go to dashboard
        </Button>
      </div>
    </div>
  );
}
